import { render } from "./Header.vue?vue&type=template&id=bfda5ce8&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=bfda5ce8&lang=scss&scoped=true"

import exportComponent from "/Users/vee/Desktop/git/web/bitcoooPcWebsite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfda5ce8"]])

export default __exports__